const notifications = {
  title: "Notifications",
  allNotifications: "All notifications",
  markAsRead: "Mark as Read",
  seeAllNotifications: "See all notifications",
  seeMore: "See More",
  loadMore: "Load more notification",
  unreadCount: "{count} unread",
  allRead: "All read",
  allCaughtUp: "You're all caught up",
  emptyDescription: "No notifications yet. We'll let you know when something comes in.",
  today: "Today",
  yesterday: "Yesterday",
  earlier: "Earlier",
  noNotifications: "There is no notifications to show",
  notificationsSupportAlert:
    "Kindly note that the notifications are not supported in your current browser version, Please update to the latest one.",
};

export default notifications;
